import { cva } from "class-variance-authority";

/**
 * CVA variants for subscription card components
 * Provides standardized styling with brand color flexibility
 */
export const subscriptionCardVariants = cva(
	"flex flex-col rounded-2xl border transition-colors duration-200",
	{
		variants: {
			variant: {
				default:
					"border-gray-200 bg-white hover:border-gray-300 dark:border-white/8 dark:bg-white/5 dark:hover:border-white/15",
				highlighted:
					"border-2 border-brand-500 bg-white shadow-theme-xl dark:border-brand-500 dark:bg-white/5",
			},
			status: {
				active:
					"border-green-200 bg-green-50/50 dark:border-green-900/50 dark:bg-green-900/10",
				pending:
					"border-orange-200 bg-orange-50/50 dark:border-orange-900/50 dark:bg-orange-900/10",
				canceled:
					"border-red-200 bg-red-50/50 dark:border-red-900/50 dark:bg-red-900/10",
				expired:
					"border-gray-200 bg-gray-50/50 dark:border-gray-800 dark:bg-gray-900/10",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

/**
 * Badge variants for subscription status indicators
 */
export const subscriptionBadgeVariants = cva(
	`
   inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-bold
   shadow-sm
 `,
	{
		variants: {
			status: {
				active:
					"border-green-200 bg-green-50 text-green-700 dark:border-green-500/20 dark:bg-green-500/10 dark:text-green-400",
				pending:
					"border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-400",
				canceled:
					"border-red-200 bg-red-50 text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-400",
				trial:
					"bg-brand-50 text-brand-700 border-brand-200 dark:bg-brand-500/10 dark:text-brand-400 dark:border-brand-500/20",
				expired:
					"border-gray-200 bg-gray-50 text-gray-700 dark:border-gray-500/20 dark:bg-gray-500/10 dark:text-gray-400",
			},
		},
		defaultVariants: {
			status: "active",
		},
	},
);

/**
 * Modal section variants for consistent layout
 */
export const modalSectionVariants = cva("rounded-xl border p-4", {
	variants: {
		variant: {
			default: "border-gray-100 bg-gray-50 dark:border-white/5 dark:bg-white/3",
			highlighted:
				"border-gray-100 bg-white dark:border-white/10 dark:bg-white/5",
			warning:
				"border-orange-100 bg-orange-50 dark:border-orange-900/20 dark:bg-orange-900/10",
		},
	},
	defaultVariants: {
		variant: "default",
	},
});

/**
 * Feature list item variants
 */
export const featureItemVariants = cva(
	"flex size-5 shrink-0 items-center justify-center rounded-full",
	{
		variants: {
			included: {
				true: "bg-brand-50 text-brand-500 dark:bg-brand-500/10 dark:text-brand-400",
				false: "bg-gray-100 text-gray-400 dark:bg-gray-800 dark:text-gray-600",
			},
		},
		defaultVariants: {
			included: true,
		},
	},
);
